module.exports = __webpack_public_path__ + "img/copy-page.e0b449dc.svg";